import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const deliveredOrdersFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
